<template>
  <body>
    <base-card>
      <Dots />
      <h1 class="showcase-name">Mansur</h1>
      <div class="transition transition-projects"></div>

      <!-- Main Content -->
      <main class="container">
        <div class="section-title">
          <h2 class="section-title__heading">Projects</h2>
          <p class="section-title__subtitle">
            a subjective collection of projects that I most enjoyed.
          </p>
        </div>

        <div class="projects">
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">Natours</h2>
              <span class="take-me">
                <a href="https://natours-mansur.herokuapp.com/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>
                This full stack web application is specially designed for
                persons who love travelling and going on tour vacations. This
                web application allows it's users to book tour vacations. A tour
                refers to a series of locations, specially picked to excite the
                adventurous spirit of the individual who books it. (PC Friendly)
              </p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/natours"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>Pug</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>Node.js (Express) <span>·</span></li>
                <li>MongoDB</li>
              </ul>
            </div>
          </article>
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">MuzoNinja</h2>
              <span class="take-me">
                <a href="https://muzo-ninjas.web.app/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>
                This web application uses Vue.js for front-end and firebase
                database for backend. Application allows to create music
                playlists and organize multiple playlists. To start using it,
                sign up with your email account!
              </p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/muzoNinja"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>HTML</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>Vue.js</li>
              </ul>
            </div>
          </article>
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">Find Coach</h2>
              <span class="take-me">
                <a href="https://find-a-coach-737bb.web.app/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>
                The entire web application is built with Vue.js on the front end
                and a Firebase database on the back end. On this web app u can
                find coach on particular area or become a coach for others. To
                start interactine, you need to sign up!
                <a
                  href="https://www.udemy.com/user/maximilian-schwarzmuller/"
                  target="blank"
                  class="link"
                  >(Designed by Maximilian Schwarzmüller )</a
                >
              </p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/findCoach"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>HTML</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>Vue.js</li>
              </ul>
            </div>
          </article>
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">Bankist</h2>
              <span class="take-me">
                <a href="https://bankist-mansur.firebaseapp.com/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>
                Originally founded by
                <a
                  href="https://www.udemy.com/user/jonasschmedtmann/"
                  target="blank"
                  class="link"
                  >Jonas Schmedtmann</a
                >, Bankist is a landing page for the virtual bank which was
                built with HTML, CSS,
                <a
                  href="https://github.com/MansurIsakov/web-projects/tree/main/bankist"
                  target="blank"
                  class="link"
                  >JavaScript</a
                >
                Then, I wholly rewrite the project with Vue.js on my own.
              </p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/web-projects/tree/main/vue-practice/bankist"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>HTML</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>Vue.js</li>
              </ul>
            </div>
          </article>
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">Forkify</h2>
              <span class="take-me">
                <a href="https://forkify-mansur.netlify.app/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>
                <a
                  href="https://www.udemy.com/user/jonasschmedtmann/"
                  target="blank"
                  class="link"
                  >Jonas Schmedtmann,</a
                >
                Forkify is a web application for collecting many recipes which
                was built with HTML, CSS, JavaScript.
              </p>
              <p>
                Forkify lets you search food recipes by names, ingredients, and
                composition, all at once. It may be great for discovering
                recipes.
              </p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/forkify"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>HTML</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>JavaScript</li>
              </ul>
            </div>
          </article>
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">Mapty</h2>
              <span class="take-me">
                <a href="https://mapty-mansur.netlify.app/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>
                This project was created to practice Object-oriented programming
                with JavaScript under the course of
                <a
                  href="https://www.udemy.com/user/jonasschmedtmann/"
                  target="blank"
                  class="link"
                  >Jonas Schmedtmann.</a
                >
                The website is designed to visually display cardiovascular
                workouts (running / cycling) on maps using the
                <a
                  href="https://leafletjs.com/reference-1.7.1.html"
                  target="blank"
                  class="link"
                  >Leaflet API</a
                >
                and Local Storage API.
              </p>
              <p>
                To start using app, simply mark a location where you want to
                workout.
              </p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/web-projects/tree/main/mapty"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>HTML</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>JavaScript</li>
              </ul>
              <br />
            </div>
          </article>
          <article class="project flex-center">
            <div class="project__title">
              <h2 class="section-heading">Old Portfolio</h2>
              <span class="take-me">
                <a href="https://old-mansur-isakov.netlify.app/" target="blank"
                  >Take Me There &RightArrow;</a
                >
              </span>
            </div>
            <div class="paragraph text">
              <p>This is my old version of portfolio website. Check it out!</p>
              <p>
                You can find the
                <a
                  href="https://github.com/MansurIsakov/web-projects/tree/main/old-portfolio"
                  target="blank"
                  class="link"
                  >GitHub repo here.</a
                >
              </p>
              <ul>
                <li>HTML</li>
                <li><span>·</span> CSS <span>·</span></li>
                <li>JavaScript</li>
              </ul>
              <br />
            </div>
          </article>
        </div>
      </main>
      <!-- End Main Content -->
    </base-card>
  </body>
</template>

<script>
import Dots from "@/components/Dots.vue";

export default {
  components: {
    Dots,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
// Section Settings
.bg {
  background-color: var(--secondary-color);
}
body {
  color: var(--primary-color);
}
h1 {
  background-color: var(--tertiary-color);
}
// End Section Settings

// Section Title
.section-title {
  &__heading {
    color: var(--tertiary-color);
  }
  &__subtitle {
    color: var(--primary-color);
  }
}
// End Section Title

// Content
.project {
  &:not(:last-child) {
    margin-bottom: 60px;
  }

  .project__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 50px;

    .take-me {
      background-color: var(--tertiary-color);
      display: flex;
      align-items: center;
      text-transform: uppercase;
      transition: all 0.3s;
      position: relative;
      overflow: hidden;
      z-index: 1;
      a {
        text-decoration: none;
        display: inline-block;
        color: var(--secondary-color);
        background-size: 205% 100%;
        background-position: 100% 0;
        padding: 0.5rem;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 2px;
        transition: background-position 0.35s ease-in-out;
      }

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--tertiary-color);
        z-index: -2;
      }
      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        height: 100%;
        background-color: darken(#112d4e, 15%);
        transition: all 0.6s;
        z-index: -1;
      }
      &:hover {
        color: #fff;
        &:before {
          width: 100%;
        }
      }
    }
  }

  .paragraph {
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      opacity: 0.75;
      margin-top: 50px;

      li span {
        margin: 0 5px;
      }

      li:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
// End Content

/* Adaptives */
@media only screen and (max-width: 64em) {
  // Content
  .project {
    &:not(:last-child) {
      margin-bottom: 50px;
    }

    .project__title {
      .take-me {
        margin-right: 10px;
        a {
          font-size: 0.7rem;
          letter-spacing: 1.8px;
        }
      }
    }

    .paragraph {
      ul {
        font-size: 12.5px;
      }
    }
  }
  // End Content
}
@media only screen and (max-width: 30em) {
  .project {
    .project__title {
      .take-me {
        margin-right: 10px;
        a {
          font-size: 0.5rem;
          letter-spacing: 1.5px;
        }
      }
    }
  }
}
/* End Adaptives */
</style>
